import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, InputAdornment, SxProps, TextField, Theme } from '@mui/material'
import React, { useState } from 'react'
import type { WsrTagNumberSearchResult } from '../../../services/WSRService'
import TimeEntrySelectWsrTagDialog from './TimeEntrySelectWsrTagDialog'

type TimeEntryWsrTagAutocompleteProps = {
	value: string
	onChange: (value: string, tag?: WsrTagNumberSearchResult) => void
	displayValue?: string
	projectOption?: string
	disabled?: boolean
	sx?: SxProps<Theme>
	label?: string
	placeholder?: string
}

export default function TimeEntryWsrTagAutocomplete({
	value,
	onChange,
	displayValue,
	projectOption,
	disabled = false,
	sx,
	label = 'Tag',
	placeholder = 'Click to select...',
}: TimeEntryWsrTagAutocompleteProps) {
	const [dialogOpen, setDialogOpen] = useState(false)

	const handleSelect = (tagId: string, tag?: WsrTagNumberSearchResult) => {
		onChange(tagId, tag)
		setDialogOpen(false)
	}

	return (
		<>
			<TextField
				label={label}
				placeholder={placeholder}
				value={value ? displayValue ?? value : ''}
				onClick={() => {
					if (!disabled) setDialogOpen(true)
				}}
				fullWidth
				size='small'
				disabled={disabled}
				sx={sx}
				InputProps={{
					readOnly: true,
					sx: { cursor: disabled ? 'default' : 'pointer' },
					startAdornment: (
						<InputAdornment position='start'>
							<SearchIcon fontSize='small' />
						</InputAdornment>
					),
					endAdornment:
						value && !disabled ? (
							<InputAdornment position='end'>
								<IconButton
									size='small'
									aria-label='Clear tag'
									onClick={(e) => {
										e.stopPropagation()
										onChange('')
									}}
								>
									<ClearIcon fontSize='small' />
								</IconButton>
							</InputAdornment>
						) : undefined,
				}}
				inputProps={{ style: { cursor: disabled ? 'default' : 'pointer' } }}
			/>
			<TimeEntrySelectWsrTagDialog
				open={dialogOpen}
				value={value}
				projectOption={projectOption}
				onClose={() => setDialogOpen(false)}
				onSelect={handleSelect}
			/>
		</>
	)
}
